import React, { useContext, useEffect, useRef, useState } from "react";
import "./AdvertiserProfile.css";
import { ProfileUpdate } from "../../App";
import { API } from "../../constants/Api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
function AdvertiserProfile() {
  const advertiserId = localStorage.getItem("advertiserId");
  const [agentEmail, setEmail] = useState("");
  const [agentPhone, setPhone] = useState("");
  const token = localStorage.getItem("token");

  const { profileUpdateState, setProfileUpdateState } =
    useContext(ProfileUpdate);

  const [loading, setLoading] = useState(false);
  const [website, setWebsite] = useState("");
  const [socialMedia, setSocialMedia] = useState("");
  // const [areaof_Operation, setAreaOfOperation] = useState("");
  const [agentzipCode, setCode] = useState([]);
  const [contentof_detailPage, setContentOfDetailPage] = useState("");
  const [listing, setListing] = useState(false);
  const [titleCompany, setTitileCompany] = useState("")
  const [home, setHome] = useState(false);
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]); // New state for selected options

  useEffect(() => {
    const getOptions = async (company) => {
      if (!company) return; // Prevent unnecessary API calls
  
      const data = { titleCompany: company };
  
      try {
        const response = await fetch(`${API}/auth/role-check/get-allZipCodes-advertisers`, {
          method: "POST",
          headers: { "Content-Type": "application/json" }, // Fix: Add headers
          body: JSON.stringify(data),
        });
  
        const json = await response.json();
  
        if (response.ok) {
          const aqdas = json.zipcodes.map((zip) => ({
            label: zip,
            value: zip,
          }));
          if(agentzipCode.length > 0){
           
            const aditionalSelected = agentzipCode.map((zip) => ({
              label: zip,
              value: zip,
            }));
            console.log(selectedOptions)
            setOptions([...aqdas, ...aditionalSelected]);
          }else{
            setOptions(aqdas)
          }
  
       
  
          // Fix: Properly add "90001" as an extra option
       
        }
      } catch (error) {
        toast.error(error.message);
      }
    };
  
    if (titleCompany && titleCompany.length > 1 && agentzipCode.length > 0) {
      getOptions(titleCompany);
    } else {
      setOptions([]); // Fix: Ensure options reset when titleCompany is empty
    }
  }, [titleCompany]);
  

  const colorStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#1e1e1e",
      borderColor: state.isFocused ? "#1e1e1e" : "#1e1e1e",
      boxShadow: state.isFocused ? "none" : "none",
      borderRadius: "20px", // Adjust the border-radius as needed
      minHeight: "66px", // Increase the height
      padding: "10px",
      "&:hover": {
        borderColor: "#1e1e1e",
      },
      "&:focus": {
        borderColor: "#1e1e1e",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#24A97B"
        : state.isFocused
          ? "#1e1e1e"
          : "#1e1e1e",
      borderRadius: "20px",

      color: state.isSelected ? "black" : "white",
      "&:hover": {
        backgroundColor: "#000000",
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#1e1e1e",
      border: "1px solid #1e1e1e",
      borderRadius: "20px", // Add border-radius to the dropdown menu
      fontFamily: "Degular-Light",
      fontSize: "14px",
      padding: "10px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
      opacity: "0.7",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    input: (base) => ({
      ...base,
      color: "#ffffff",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#000000",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#ffffff",
      "&:hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  const handleZipChange = (selectedOption1) => {
    setSelectedOptions(selectedOption1 || []);
  };

  function formValidations() {
    if (website.length < 1) {
      toast.error("Website is required");
      return false;
    }

    if (socialMedia.length < 1) {
      toast.error("Social Media is required");
      return false;
    }
    if (agentzipCode.length < 1) {
      toast.error("Please select atleast 1 Areas Of Operation");
      return false;
    }
    if (contentof_detailPage.length < 1) {
      toast.error("Content of Detail Page is required");
      return false;
    }
    if (!listing && !home) {
      toast.error("Please check altleat one of featured");
      return false;
    }

    return true;
  }
  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = await formValidations();

    if (isValid) {
      setLoading(true);
      const newZips = selectedOptions.map((zip)=>zip.value)
      const data = {
        email: agentEmail,
        businessInfo: {
          website: website,
          socialMedia: socialMedia,
          areaof_Operation: newZips,
          contentof_detailPage: contentof_detailPage,
          numberof_Sections:
            listing && home ? "2" : listing ? "1.1" : home ? "1.2" : undefined,
        },
      };

      try {
        const response = await fetch(
          `${API}/advertiser/advertiser-business-info`,
          {
            method: "PUT",
            body: JSON.stringify(data),
            headers: {
              "Content-Type": "Application/json",
            },
          }
        );

        const json = await response.json();
        if (response.ok) {
          toast.success(json.message);
        } else {
          toast.error(json.message);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const response = await fetch(
          `${API}/advertiser/get-Advertiser/${advertiserId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await response.json();

        if (response.ok) {
          setPhone(json.data.phoneNumber);

       
          setEmail(json.data.email);
          setTitileCompany(json.data.titleCompany);
          const businessInfo = json.data.advertiserBussninesinfo || {};
          
          setWebsite(businessInfo.website || "");
          setSocialMedia(businessInfo.socialMedia || "");
          setContentOfDetailPage(businessInfo.contentof_detailPage || "");
          
           // Store areaOfOperations in state first
        const areaOfOperations = businessInfo.areaof_Operation || [];
        setCode(areaOfOperations);

        // Wait for options to update, then set selectedOptions
        if (areaOfOperations.length > 0) {
          setSelectedOptions((prevSelected) =>
            options.length > 0
              ? options.filter((opt) => areaOfOperations.includes(opt.value))
              : prevSelected
          );
        }
          
          // Handle number of sections
          const numSections = businessInfo.numberof_Sections;
          if (numSections === "2" || numSections === 2) {
            setListing(true);
            setHome(true);
          } else if (numSections === "1.1" || numSections === 1.1) {
            setListing(true);
            setHome(false);
          } else if (numSections === "1.2" || numSections === 1.2) {
            setListing(false);
            setHome(true);
          } else {
            setListing(false);
            setHome(false);
          }
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    getUserInfo();
  }, [profileUpdateState, options]); // Added options to dependencies
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="user-profile">
      <h2 className="user-layout-page-heading">Profile Info</h2>
      <div className="container-fluid">
        <div className="row">
        <div className="col-12 px-0 py-1">
            <hr className="text-white" style={{ opacity: "0.05" }} />
          </div>
          <div className="col-lg-7 px-0 py-1">
            <p className="user-profile-picture">Account Details</p>

            <input
              type="email"
              className="form-control user-profile-input-field"
              id="exampleInputPassword1"
              placeholder="Email address"
              value={agentEmail}
              readOnly

              // onChange={(e) => setEmail(e.target.value)}
            />
              {isMobile ? (
              <input
                type="tel"
                className="form-control user-profile-input-field"
                id="userPhone"
                placeholder="Phone number"
                value={`+1 ${agentPhone}`} // Display "+1" prefix
                readOnly
              />
            ) : (
              <div className="user-profile-phone-number-group">
                <button className="user-profile-phone-code">+1</button>
                <input
                  type="number"
                  className="form-control user-profile-phone-field"
                  id="exampleInputPassword1"
                  placeholder="Phone Number"
                  value={agentPhone}
                  readOnly
                  // onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            )}
          </div>
          <div className="col-12 px-0 py-1">
            <hr className="text-white" style={{ opacity: "0.05" }} />
          </div>
          <div className="col-md-7 px-0 mx-0">
          <p className="user-profile-picture">Business Details</p>
              <input
                type="text"
                className="form-control user-profile-input-field"
                id="exampleInputEmail1"
                placeholder="Your Website"
                aria-describedby="emailHelp"
                // onChange={(e) => setWebsite(e.target.value)}
                value={website}
                readOnly
              />

              <input
                type="text"
                className="form-control user-profile-input-field"
                id="exampleInputPassword1"
                placeholder="Social media"
                // onChange={(e) => setSocialMedia(e.target.value)}
                value={socialMedia}
                readOnly
              />
              {/* <input
                type="text"
                className="form-control agent-register-input-field"
                id="exampleInputPassword1"
                placeholder="Area of Operation (Comma separated)"
                onChange={(e) => setAreaOfOperation(e.target.value)}
              /> */}
              <Select
                isMulti
                name="colors"
                styles={colorStyles}
                // options={options}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Areas Of Operations"
                // onChange={handleZipChange}
                value={selectedOptions}
                isDisabled
              />
              <hr
                className="text-white agent-register-devider-1"
                style={{ opacity: "0.1" }}
              />
              <textarea
                type="text"
                className="form-control before-begin-text-area"
                id="exampleInputPassword1"
                placeholder="An Overview of Your Business Operations and Objectives"
                rows={5}
                // onChange={(e) => setContentOfDetailPage(e.target.value)}
                value={contentof_detailPage}
                readOnly
              />
              {/* <p className="before-begin-span">
                Showcase your service on the website or home search page for
                your zip codes. Choose one or both options.
              </p>
              <div className="d-flex gap-5">
                <div className="mb-3 form-check agent-register-verify-check-group px-0">
                  <img
                    role="button"
                    onClick={() => setListing(!listing)}
                    src={`${listing ? "/img/checked.svg" : "/img/uncheck.svg"}`}
                    className="img-fluid"
                    alt=""
                  />

                  <label
                    className="form-check-label ms-3"
                    htmlFor="exampleCheck1"
                  >
                    Listing Featured (main website page)
                  </label>
                </div>
                <div className="mb-3 form-check agent-register-verify-check-group px-0">
                  <img
                    role="button"
                    onClick={() => setHome(!home)}
                    src={`${home ? "/img/checked.svg" : "/img/uncheck.svg"}`}
                    className="img-fluid"
                    alt=""
                  />

                  <label
                    className="form-check-label ms-3"
                    htmlFor="exampleCheck1"
                  >
                    Home Search / Detail Page
                  </label>
                </div>
              </div> */}

       
           
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdvertiserProfile;
